import { useLayoutEffect, useState } from "react";
import { useModalContext } from "./useModalContext";
import useCookie from "./useCookie";

// 7일간 모지않기 관련 hook
const useNoview7days = (cookieKey: string, expires: number, version: string) => {
  const { setCookie, getCookie } = useCookie();
  const { closeModal } = useModalContext();

  const [isClickedNoview7days, setIsClickedNoview7days] =
    useState<boolean>(false);

  const fetchGetCookie = () => {
    const cookieValue = getCookie(cookieKey);
    const hideModal = cookieValue === "true";
    //true면 안 보이게, false면 보이게끔
    if (hideModal) {
      closeModal();
    }
  };
  useLayoutEffect(() => {
    //initState
    fetchGetCookie();
  }, []);

  const setNoview7daysCookies = async (newValue: boolean) => {
    const cookieData = JSON.stringify({ isHidden: newValue, version });
    setCookie(cookieKey, cookieData, expires);
  };

  return {
    isClickedNoview7days,
    setIsClickedNoview7days,
    setNoview7daysCookies,
  };
};

export default useNoview7days;
